import { render } from "./ButtonLink.vue?vue&type=template&id=0961c020&ts=true"
import script from "./ButtonLink.vue?vue&type=script&lang=ts"
export * from "./ButtonLink.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__